import React from 'react';

const feedRows = [
  ['alice@startup.com', 'src/components/Button.tsx', '+24s'],
  ['bob@startup.com', 'api/routes/auth.ts', '+8s'],
  ['alice@startup.com', 'src/pages/Dashboard.tsx', '+41s'],
  ['bob@startup.com', 'supabase/migrations/001.sql', '+12s'],
];

export function ActivityFeed() {
  const rows = [...feedRows, ...feedRows];

  return (
    <div className="activity-feed" aria-hidden="true">
      <div className="activity-feed__track">
        {rows.map((row, index) => (
          <div className="activity-feed__row" key={`${row[1]}-${index}`} style={{ animationDelay: `${index * 90}ms` }}>
            <span className="activity-feed__dot">●</span>
            <span className="activity-feed__email">{row[0]}</span>
            <span className="activity-feed__file">{row[1]}</span>
            <span className="activity-feed__time">{row[2]}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
